
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^order(Cancel|Check|Modify)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
